import styled from 'styled-components'
import { LinkIcon } from '../../assets/images'

export const LinkIconStyled = styled(LinkIcon)`
  vertical-align: bottom;
  margin-left: 5px;
`
